/**
 * String.prototype.replaceAll() polyfill
 * Pushes support back to IE6
 */
if (!Promise.allSettled) {
	Promise.allSettled = function (promises) {
		return Promise.all(
			promises.map((promise) =>
				Promise.resolve(promise).then(
					(value) => ({ status: 'fulfilled', value }),
					(reason) => ({ status: 'rejected', reason }),
				),
			),
		);
	};
}
